import { useState, useEffect, useRef, useMemo } from 'react'
import { isCancel } from 'axios'
import { getApiClient } from '../api'
import type { RevisionsResponse } from '../api'
import type { ActiveFilters } from '../types/Stats'

export function useStatsRevisions(
  scope:          string,
  geo:            string,
  metric:         string | null,
  appliedFilters: ActiveFilters,
) {
  const [revisionsData,  setRevisionsData]  = useState<RevisionsResponse | null>(null)
  const [revisionsError, setRevisionsError] = useState(false)
  const abortRef = useRef<AbortController | null>(null)

  // yearRange a compareGeo sa pri revisions ignorujú
  const fetchKey = useMemo(() => {
    if (!metric) return null
    const { yearRange: _yr, compareGeo: _cg, ...rest } = appliedFilters
    return JSON.stringify({ scope, geo, metric, ...rest })
  }, [scope, geo, metric, appliedFilters])

  useEffect(() => {
    if (!metric || !fetchKey) return

    abortRef.current?.abort()
    const controller = new AbortController()
    abortRef.current = controller
    setRevisionsError(false)

    const { yearRange: _yr, compareGeo: _cg, source, unit, ...dimFilters } = appliedFilters

    getApiClient()
      .getRevisionsByScope(
        scope,
        { geo, metric, source, unit, ...dimFilters },
        { signal: controller.signal },
      )
      .then(data => setRevisionsData(data))
      .catch(err => { if (!isCancel(err)) setRevisionsError(true) })

    return () => controller.abort()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [fetchKey])

  return { revisionsData, revisionsError }
}